import { request } from '../../shared/verb';
import { setPermissions } from '../actions/permissions';

export const getAllPermissions = (dispatch) => () =>
  request(`/permission`, 'get').then((res) => {
    dispatch(setPermissions(res.data));
    return res.data;
  });
